import React, { Component } from 'react';
import MaskedInput from 'react-maskedinput'
import './styles.css';

export default class DateField extends Component {
  _onChange = (e) => {
    this.props.onChange(e.target.value);
  }

  render() {
    const { value, label, error } = this.props;
    return (
      <div className={`text__input date_input ${error ? 'text__input--error error' : ''}`}>
          <label htmlFor={label} className={value !== "" ? "date__input__label_hidden type__input__label" :"date__input__label type__input__label"}>Birthdate</label>
        <MaskedInput
          className={`date__input__field  type__input__field ${error ? 'error' : ''}`}
          mask="11/11/1111"
          placeholder="(mm/dd/yyyy)"
          value={value}
          onChange={this._onChange}
        />
      </div>
    )
  }
};



// WEBPACK FOOTER //
// ./src/components/DateField/DateField.js